import { motion } from "framer-motion";
import { Mail, Phone, MessageCircle } from "lucide-react";

export default function HelpChoice() {
  return (
    <section
      id="aide"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-20 bg-cream"
      data-testid="help-section"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="max-w-[1100px] mx-auto"
      >
        <div className="relative rounded-[32px] bg-walnut text-cream p-10 md:p-16 lg:p-20 overflow-hidden">
          {/* Ambient */}
          <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-terracotta/15 blur-[100px] pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-[300px] h-[300px] rounded-full bg-sage/15 blur-[100px] pointer-events-none" />

          <div className="relative grid md:grid-cols-12 gap-10 items-center">
            <div className="md:col-span-7">
              <div className="flex items-center gap-3 mb-6">
                <MessageCircle size={16} className="text-terracotta" />
                <span className="text-[10px] uppercase tracking-[0.3em] text-cream/60">
                  Conseil personnalisé
                </span>
              </div>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[0.95]">
                Besoin d'aide pour <br />
                <span className="italic-serif text-terracotta">choisir le bon instrument ?</span>
              </h2>
              <p className="mt-8 text-base md:text-lg text-cream/75 font-light leading-relaxed max-w-xl">
                Nous sommes disponibles pour vous orienter vers le handpan, le
                gong, le Koshi ou l'accessoire qui correspond le mieux à votre
                envie, votre pratique et votre sensibilité.
              </p>
            </div>

            <div className="md:col-span-5 space-y-3">
              <a
                href="mailto:contact@soundyoga.fr"
                className="group flex items-center gap-4 p-5 rounded-2xl bg-cream/5 hover:bg-terracotta border border-cream/10 hover:border-terracotta transition-all duration-500"
                data-testid="help-cta-email"
              >
                <div className="w-12 h-12 rounded-full bg-terracotta group-hover:bg-cream flex items-center justify-center transition-colors">
                  <Mail size={18} className="text-cream group-hover:text-terracotta transition-colors" />
                </div>
                <div className="flex-1">
                  <div className="text-[10px] uppercase tracking-[0.2em] text-cream/60 group-hover:text-cream/80">
                    Écrire à Yogi Market
                  </div>
                  <div className="font-serif text-lg text-cream">contact@soundyoga.fr</div>
                </div>
                <span className="text-cream/40 group-hover:text-cream group-hover:translate-x-1 transition-all">→</span>
              </a>
              <a
                href="tel:+33767396699"
                className="group flex items-center gap-4 p-5 rounded-2xl bg-cream/5 hover:bg-cream border border-cream/10 hover:border-cream transition-all duration-500"
                data-testid="help-cta-call"
              >
                <div className="w-12 h-12 rounded-full bg-sage group-hover:bg-walnut flex items-center justify-center transition-colors">
                  <Phone size={18} className="text-cream" />
                </div>
                <div className="flex-1">
                  <div className="text-[10px] uppercase tracking-[0.2em] text-cream/60 group-hover:text-walnut/60">
                    Appeler le studio
                  </div>
                  <div className="font-serif text-lg text-cream group-hover:text-walnut">07 67 39 66 99</div>
                </div>
                <span className="text-cream/40 group-hover:text-walnut group-hover:translate-x-1 transition-all">→</span>
              </a>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}
